import {CheckOutlined} from '@ant-design/icons';
import React from 'react';

const ReadAllButton = ({onClick}) => {
    return (
        <div
            onClick={onClick}
            className='
                group flex items-center justify-center
                h-[30px] px-1.5 rounded-full cursor-pointer
                transition-all duration-300 ease-in-out
                border border-transparent hover:border-whisper
                bg-transparent hover:bg-solitude
                text-nobel hover:text-charcoal
            '
            style={{userSelect: 'none'}}
        >
            <span className='relative flex items-center justify-center w-5 h-5 flex-shrink-0 transition-colors duration-300'>
                <CheckOutlined className='absolute left-0 text-[12px]' />
                <CheckOutlined className='absolute left-[6px] text-[12px]' />
            </span>

            <span
                className='
                overflow-hidden whitespace-nowrap text-12 font-medium tracking-01
                max-w-[100px] opacity-100 ml-1 pr-2 transition-all duration-300 ease-in-out
                md:max-w-0 md:opacity-0 md:ml-0 md:pr-0
                md:group-hover:max-w-[100px] md:group-hover:opacity-100 md:group-hover:ml-1 md:group-hover:pr-2
            '
            >
                Прочитати всі
            </span>
        </div>
    );
};

export default ReadAllButton;
